module.exports = __webpack_public_path__ + "img/anders-consulting.1c064dab.png";